import request from 'sb-request'
import { reducers } from 'redux/core'


const fetchRecommendations = ({ gender, limit = 12 }) =>
  request.get('rest/shop/recommendations', {
    query: {
      gender,
      limit,
    },
  })
    .then(({ items }) => {
      reducers.view.recommendationsPage.setItems(items)

      return items
    })

const fetchQuizRecommendations = () =>
  request.post('graphql?name=quizRecommendations', {
    body: {
      query: `{
        quizRecommendations {
         id
         url
         name
         brand
         img
         sex
         category
         type
         typeGroup
         labels
         rating
        }
       }`,
    },
    modifyResult: ({ quizRecommendations }) => quizRecommendations,
  })
    .then((items) => {
      reducers.view.recommendationsPage.setItems(items)

      return items
    })

const toggleSelectedId = (id) => reducers.view.recommendationsPage.toggleSelectedId(id)

const resetSelectedIds = () => reducers.view.recommendationsPage.resetSelectedIds()


export default {
  fetchRecommendations,
  fetchQuizRecommendations,
  toggleSelectedId,
  resetSelectedIds,
}
